const LANDING_PAGE = 'landing_page'
const REFERRER = 'referrer'

export const saveLandingToSession = () => {
  if (typeof window === 'undefined') return
  if (sessionStorage.getItem(LANDING_PAGE)) return
  sessionStorage.setItem(LANDING_PAGE, window.location.href)
  sessionStorage.setItem(REFERRER, document.referrer)
}

export const appendSessionLandingToUrl = (src: string) => {
  if (typeof window === 'undefined') return src

  const url = new URL(src)
  const landingPage = sessionStorage.getItem(LANDING_PAGE) || ''
  const referrer = sessionStorage.getItem(REFERRER) || ''

  if (!landingPage) return src
  url.searchParams.set(LANDING_PAGE, landingPage)
  url.searchParams.set(REFERRER, referrer)
  return url.toString()
}
